import http from "@/shared/services/http";

export const listReceiptPickingList = (params: any) => http.get(`v1/revenue-expenditures`, { params });
export const deleteReceiptPickingList = (id: number) => http.delete(`v1/revenue-expenditures/${id}`);
export const confirmReceiptPickingList = (id: number) => http.get(`v1/revenue-expenditures/confirm-creditor/${id}`);
export const confirmReceiptCustomerPickingList = (id: number) => http.get(`v1/revenue-expenditures/confirm-customer/${id}`);
export const confirmReceiptEmployeePickingList = (id: number) => http.get(`v1/revenue-expenditures/confirm-employee/${id}`);
